<template>
	<div class="master">
		<div class="master_head flex_c_s">
			<div class="master_head_title">{{params.title ||''}}</div>
			<div class="flex_c">
				<div class="master_head_more" :style="{color:itemStyle.moreColor}">{{params.more ||''}}</div>
				<!-- <uni-icons type="right" size="12"></uni-icons> -->
			</div>
		</div>
		<div v-for="(item,index) in dataItem" :key="index" class="master_item">
			<div class="master_item_user flex_c_s">
				<img :style="{borderRadius:params.model==2?'5px':'50%'}" class="master_item_img" :src="item.img" alt="">
				<div class="master_item_data flex1">
					<div class="master_item_name">{{item.name}}</div>
					<div class="master_item_notice">{{item.notice || ''}}</div>
					<div class="master_item_zhi flex_c_s">
						<div class="flex_c">
							<img class="master_item_icon" :src="itemStyle.gangimg" alt="" />
							<span class="master_item_gang">{{item.zhiwei || ''}}</span>
						</div>
						<div class="master_item_but" :style="{background:itemStyle.btnColor}">{{params.buttext ||''}}</div>
					</div>
				</div>
			</div>
			<div v-if="params.model==2" class="master_item_ex flex_c">
				<div class="master_item_tag" :style="{background:itemStyle.shangColor}">{{params.stext ||''}}</div>
				<div class="master_item_text flex1 ellipsis">{{item.shang || ''}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  components: {
	  },
	  props: {
	    // 标签文字
	    dataItem: {
			type:Array
		},
		// 标签文字
		params: {
			type:Object
		},
		itemStyle: {
			type:Object
		},
	  },
	  data () {
	    return {}
	  }
	}
</script>

<style lang="scss" scoped>
	.master{
		background-color: #fff;
		background: #FFFFFF;
		border-radius: 10px;
		margin-left: auto;
		margin-right: auto;
		padding: 16px;
		&_head{
			margin-bottom: 16px;
			&_title{
				font-weight: bold;
				font-size: 14px;
				color: #000000;
			}
			&_more{
				font-size: 12px;
				color: #C41E52;
			}
		}
		&_item{
			margin-bottom: 16px;
			&:last-child{
				margin-bottom: 0;
			}
			&_user{
				
			}
			&_img{
				width: 80px;
				height: 80px;
				border-radius: 5px;
				display: block;
				margin-right: 15px;
			}
			&_data{
				
			}
			&_name{
				font-weight: bold;
				font-size: 13px;
				color: #000000;
			}
			&_notice{
				margin-top: 9px;
				height: 31px;
				line-height: 15px;
				font-size: 12px;
				color: #999999;
			}
			&_zhi{
				margin-top: 5px;
			}
			&_but{
				height: 20px;
				line-height: 20px;
				padding-left: 11px ;
				padding-right: 11px;
				display: inline-block;
				border-radius: 10px;
				background: #C41E52;
				font-size: 11px;
				color: #FFFFFF;
			}
			&_icon{
				width: 11px;
				height: 11px;
				display: block;
				margin-right: 5px;
			}
			&_gang{
				font-size: 11px;
				color: #999999;
			}
			&_ex{
				height: 36px;
				background: #F6F6F6;
				border-radius: 5px;
				padding: 0 9px;
				margin-top: 12px;
			}
			&_tag{
				height: 20px;
				padding: 0 8px;
				background: #C41E52;
				border-radius: 4px;
				font-size: 11px;
				color: #FFFFFF;
				text-align: center;
				line-height:20px;
				margin-right: 7px;
			}
			&_text{
				font-size: 12px;
				color: #000000;
			}
		}
	}
</style>